module.exports = __webpack_public_path__ + "img/paid_invoice.08b8b3d7.png";